import { formatDateToLocal } from './dateUtils';

// SZÜLETÉSI DÁTUM — EGY szabály a weben [Web regisztráció születési dátum, 2026-10-04; 1. validátor-kör F1/M3].
// Eddig KÉT ellentmondó szabály élt: a regisztráció (`Register.tsx`) helyi-nap alapú volt, az Adatlap
// (`UserProfile.tsx`) és az admin szerkesztő (`UserProfileDialog.tsx`) `new Date('yyyy-MM-dd')`-t használt,
// ami UTC-éjfélnek olvassa a napot → a MAI napot „jövőbelinek" mondta, nem volt 1900-as alsó határ, a `max`
// attribútum pedig `toISOString()` (UTC-nap: 00:00–02:00 között tegnap). Mostantól mindhárom innen dolgozik.
// A mondatok SZÓ SZERINT a mobiléi (`mobile/utils/registerValidation.ts`); a záró mondatok a szerveréivel egyeznek.
export const DOB_REQUIRED_MESSAGE = 'A születési dátum megadása kötelező.';
export const DOB_FUTURE_MESSAGE = 'A születési dátum nem lehet jövőbeli.';
export const DOB_TOO_OLD_MESSAGE = 'A születési dátum nem lehet 1900 előtti.';
export const DOB_INVALID_MESSAGE = 'Érvénytelen dátum.';
/** A legkorábbi elfogadott születési nap (a szerver is 1900 előttit utasít el). */
export const DOB_MIN = '1900-01-01';

/** A `<input type="date">` `max` attribútuma: a HELYI mai nap (nem az UTC-nap). */
export const dobMax = (): string => formatDateToLocal(new Date());

/**
 * `yyyy-MM-dd` szövegek összevetése = naptári napok összevetése: NINCS `new Date('yyyy-MM-dd')` és
 * `toISOString()` (az UTC-nap csapdája: 00:00–02:00 között a „ma" tegnap lenne). A „ma" a HELYI nap.
 * Üres szöveg = hiba (kötelező mező); érvényesre `''`.
 */
export function dateOfBirthError(value: string, today: string = formatDateToLocal(new Date())): string {
  if (!value || !value.trim()) return DOB_REQUIRED_MESSAGE;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!m) return DOB_INVALID_MESSAGE;
  const y = Number(m[1]); const mo = Number(m[2]); const d = Number(m[3]);
  // Létező naptári nap? (2000-02-31 → érvénytelen)
  const probe = new Date(y, mo - 1, d);
  if (probe.getFullYear() !== y || probe.getMonth() !== mo - 1 || probe.getDate() !== d) return DOB_INVALID_MESSAGE;
  if (value < DOB_MIN) return DOB_TOO_OLD_MESSAGE;
  if (value > today) return DOB_FUTURE_MESSAGE;
  return '';
}
